<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Guests List</h5>
            </div>
            <div class="card">
                <div class="p-d-flex p-ai-center p-flex-column p-flex-lg-row p-mb-1">
                    <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="emp_name" :options="adminList" @change="getAdminVisitorsDetails($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select admin"
                            :style="{ minWidth: '200px' }" />
                    </div>
                    <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="host_name" :options="hostList" @change="getHostVisitorsDetails($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select host"
                            :style="{ minWidth: '200px' }" />
                    </div>
                    <div class="p-d-flex ">
                        <Dropdown v-model="branch_name" :options="branchList"
                            @change="getHostBranchVisitorsDetails($event)" optionLabel="label" appendTo="body"
                            class="p-text-capitalize" placeholder="Select branch" :style="{ minWidth: '200px' }" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <TabView v-if="visitorsdatadisplayflag">
        <TabPanel header="Live Guest List">
            <div class="card">
                <DataTable :value="LiveVisitorsDetailsList" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="LiveVisitorsTotalRecords" :loading="loading" @page="onPageChange"
                    class="p-datatable-users" data-key="aa1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :style="{ 'overflow-wrap': 'break-word' }">
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column header="Visitor Name" headerStyle="width: 35%">
                        <template #body="{ data }">
                            <div class="p-d-flex p-ai-center">
                                <div class="p-mr-3">
                                    <span v-if="data.aa15 != null && data.aa15 != ''">
                                        <img :src="data.aa15" width="50" height="50"
                                            style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                    <span v-else>
                                        <img src="/assets/layout/images/widgets/asset-profile-11.png" width="50"
                                            height="50" style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                </div>
                                <div>
                                    <div class="p-text-capitalize overflow-span">{{ data.aa9 ? data.aa9
                                        : 'N/A' }}</div>
                                    <small class="muted-text p-text-capitalize p-d-flex p-my-1"><span
                                            v-tooltip.right="'Type'">
                                            <div v-if="data.aa30 == 1"> Indian </div>
                                            <div v-else-if="data.aa30 == 2"> Foreigner </div>
                                        </span>
                                    </small>
                                    <small class="muted-text p-text-capitalize p-d-flex p-my-1"><span
                                            v-tooltip.right="'Unique System Id'">
                                            {{ data.aa80 }}
                                        </span>
                                    </small>
                                </div>
                            </div>
                        </template>
                    </Column>

                    <Column header=" Contact No." headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span class="overflow-span" v-if="allow_to_display_mobile_number">{{ data.aa13 ? data.aa13 :
                                "-" }}</span>
                            <span class="overflow-span" v-else>{{ data.aa13 ? maskMobileNumber(data.aa13) : "-"
                                }}</span>
                        </template>
                    </Column>
                    <Column header="Check In Date" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span class="overflow-span" v-tooltip.right="'Time'">
                                {{ data.aa26 ? format_timestamp(data.aa26).date : "-" }}
                            </span>
                            <small class="muted-text p-text-capitalize p-d-flex p-my-1">
                                <span v-tooltip.right="'Date'">
                                    {{ data.aa26 ? format_timestamp(data.aa26).time : "-" }}
                                </span>
                            </small>
                        </template>
                    </Column>
                    <Column header="State" headerStyle="width: 13%">
                        <template #body="{ data }">
                            <span class="overflow-span">{{ data.aa20 ? data.aa20 : "-" }}</span>
                        </template>
                    </Column>
                    <Column header="City" headerStyle="width: 12%">
                        <template #body="{ data }">
                            <span class="p-text-capitalize">{{ data.aa22 ? data.aa22 : "-" }}</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 10%" class="p-text-center">
                        <template #body="{ data }">
                            <Button icon="pi pi-eye" class="p-button-rounded p-button-success p-mr-2"
                                @click="editGuestHistoryPopUpOpen(data)" title="Show Guest History" />
                        </template>
                    </Column>
                    <!-- <Column header="Visitor Name" headerStyle="width: 25%">
                        <template #body="{ data }">
                            <div class="p-d-flex p-ai-center">
                                <div class="p-mr-3">
                                    <span v-if="data.aa15 != null && data.aa15 != ''">
                                        <img :src="data.aa15" width="50" height="50"
                                            style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                    <span v-else>
                                        <img src="/assets/layout/images/widgets/asset-profile-11.png" width="50" height="50"
                                            style="vertical-align: middle; border-radius: 75px" />
                                    </span>
                                </div>
                                <div>
                                    <div class="p-text-capitalize overflow-span">{{ data.aa9 ? data.aa9
                                        : 'N/A' }}</div>
                                </div>
                            </div>
                        </template>
                    </Column>
                    <Column header="Date" headerStyle="width: 16%">
                        <template #body="{ data }">
                            <span class="overflow-span">{{ data.aa26 ? format_timestamp(data.aa26) : "-" }}</span>
                        </template>
                    </Column>
                    <Column header="Email Id" headerStyle="width: 19%">
                        <template #body="{ data }">
                            <span class="overflow-span">{{ data.aa14 ? data.aa14 : "-" }}</span>
                        </template>
                    </Column>
                    <Column header=" Contact No." headerStyle="width: 11%">
                        <template #body="{ data }">
                            <span class="overflow-span">{{ data.aa13 ? data.aa13 : "-" }}</span>
                        </template>
                    </Column>
                    <Column header="Address" headerStyle="width: 21%">
                        <template #body="{ data }">
                            <span class="p-text-capitalize">{{ data.aa45 ? data.aa45 : "-" }}</span>
                        </template>
                    </Column>
                    <Column header="Type" headerStyle="width: 9%" class="p-text-center">
                        <template #body="{ data }">
                            <div class="p-text-capitalize">
                                <div v-if="data.aa30 == 1"> Indian </div>
                                <div v-else-if="data.aa30 == 2"> Foreigner </div>
                            </div>
                        </template>
                    </Column> -->
                </DataTable>
                <Toast />
            </div>
        </TabPanel>
    </TabView>
    <Dialog v-model:visible="openGuestHistoryPopUpStatus" :style="{ width: '900px' }" :modal="true" class="p-fluid">
        <template #header>
            <span class="p-dialog-title">Guest History</span>
        </template>
        <div class="p-col-12">
            <div class="card p-mt-2 p-ml-3 p-mr-2 p-mb-2">
                <div class="box p-text-capitalize overflow-span">
                    <span class="p-text-bold">Guest Name :</span>
                    {{ currentVisitorDetails.aa9 ? currentVisitorDetails.aa9 : 'N/A' }}
                </div>
                <Divider />

                <div class="p-grid p-mt-2">
                    <div class="p-col-12 p-md-2 p-as-center" style="width: 17%">
                        <div class="box p-text-center">
                            <span v-if="currentVisitorDetails.aa15">
                                <img :src="currentVisitorDetails.aa15" width="120" height="75"
                                    style="vertical-align: middle; border: 2px solid #ecebeb" />
                            </span>
                            <span v-if="!currentVisitorDetails.aa15">
                                <img :src="'/assets/layout/images/default_hotel.jpeg'" width="120" height="75"
                                    style="vertical-align: middle; border: 2px solid #ecebeb" />
                            </span>
                        </div>
                    </div>
                    <!-- <Divider layout="vertical" /> -->
                    <div class="p-col-12 p-md-3" style="width: 23%">

                        <div class="box p-text-capitalize overflow-span">
                            <span class="p-text-bold">Type :</span>

                            <span v-if="currentVisitorDetails.aa30 == 1"> Indian </span>
                            <span v-else-if="currentVisitorDetails.aa30 == 2"> Foreigner </span>
                        </div>

                        <div class="box p-mt-3 p-text-capitalize overflow-span">
                            <span class="p-text-bold">Contact :</span>
                            {{ currentVisitorDetails.aa13 ? currentVisitorDetails.aa13 : 'N/A' }}
                        </div>
                        <div class="box p-mt-3 p-text-capitalize overflow-span">
                            <span class="p-text-bold">Email :</span>
                            {{ currentVisitorDetails.aa14 ? currentVisitorDetails.aa14 : 'N/A' }}
                        </div>
                        <div class="box p-mt-3 p-text-capitalize overflow-span">
                            <span class="p-text-bold">Blood Group :</span>
                            {{ currentVisitorDetails.aa79 ? currentVisitorDetails.aa79 : 'N/A' }}
                        </div>

                    </div>
                    <Divider layout="vertical" />
                    <div class="p-col-12 p-md-3" style="width: 23%">
                        <div class="box  p-text-capitalize overflow-span">
                            <span class="p-text-bold">Country:</span>
                            {{ currentVisitorDetails.aa18 ? currentVisitorDetails.aa18 : 'N/A' }}
                        </div>
                        <div class="box p-mt-3 p-text-capitalize overflow-span">
                            <span class="p-text-bold">State:</span>
                            {{ currentVisitorDetails.aa20 ? currentVisitorDetails.aa20 : 'N/A' }}
                        </div>
                        <div class="box p-mt-3 p-text-capitalize overflow-span">
                            <span class="p-text-bold">City :</span>
                            {{ currentVisitorDetails.aa22 ? currentVisitorDetails.aa22 : 'N/A' }}
                        </div>
                        <div class="box p-mt-3 p-text-capitalize overflow-span">
                            <span class="p-text-bold">Area :</span>
                            {{ currentVisitorDetails.aa24 ? currentVisitorDetails.aa24 : 'N/A' }}
                        </div>
                        <div class="box p-mt-3 p-text-capitalize">
                            <span class="p-text-bold">Address : </span>
                            {{ currentVisitorDetails.aa45 ? currentVisitorDetails.aa45 : 'N/A' }}
                        </div>
                    </div>
                    <Divider layout="vertical" />
                    <div class="p-col-12 p-md-4" style="width: 25%">
                        <div class="box p-text-capitalize">
                            <span class="p-text-bold">Visiting From : </span>
                            {{ currentVisitorDetails.aa42 ? currentVisitorDetails.aa42 : 'N/A' }}
                        </div>
                        <div class="box p-mt-3 p-text-capitalize">
                            <span class="p-text-bold">Visiting Till :</span>
                            {{ currentVisitorDetails.aa43 ? currentVisitorDetails.aa43 : 'N/A' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <DataTable :value="guestHistoryList" :lazy="true" :paginator="true" :rows="30" :totalRecords="guestHistoryCount"
            :loading="loading" @page="onPageChange" class="p-datatable-users" data-key="ab1" :rowHover="true"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            :style="{ 'overflow-wrap': 'break-word' }">
            <template #empty> No data found. </template>
            <template #loading> Loading data. Please wait... </template>
            <Column header=" Host Name" headerStyle="width: 15%">
                <template #body="{ data }">
                    <span class="overflow-span">{{ data.ab5 ? data.ab5 : "-" }}</span>
                </template>
            </Column>
            <Column header=" Branch Name" headerStyle="width: 15%">
                <template #body="{ data }">
                    <span class="overflow-span">{{ data.ab9 ? data.ab9 : "-" }}</span>
                </template>
            </Column>
            <Column header=" Guest Entry Time" headerStyle="width: 15%">
                <template #body="{ data }">
                    <span class="overflow-span" v-tooltip.right="'Time'">
                        {{ data.ab6 ? format_timestamp(data.ab6).date : "-" }}
                    </span>
                    <small class="muted-text p-text-capitalize p-d-flex p-my-1">
                        <span v-tooltip.right="'Date'">
                            {{ data.ab6 ? format_timestamp(data.ab6).time : "-" }}
                        </span>
                    </small>
                </template>
            </Column>
            <Column header=" Guest Exit Date Time" headerStyle="width: 15%">
                <span class="overflow-span" v-tooltip.right="'Time'">
                    {{ data.ab7 ? format_timestamp(data.ab7).date : "-" }}
                </span>
                <small class="muted-text p-text-capitalize p-d-flex p-my-1">
                    <span v-tooltip.right="'Date'">
                        {{ data.ab7 ? format_timestamp(data.ab7).time : "-" }}
                    </span>
                </small>
            </Column>
            <Column header="Room No." headerStyle="width: 13%">
                <template #body="{ data }">
                    <span class="overflow-span">{{ data.ab10 ? data.ab10 : "-" }}</span>
                </template>
            </Column>
        </DataTable>
        <Toast />
        <!-- </div> -->
    </Dialog>
</template>
<script>
import ApiService from '../../service/ApiService';
import moment from 'moment';

export default {
    data() {
        return {
            adminList: [],
            hostList: [],
            branchList: [],
            page_no: 0,
            LiveVisitorsTotalRecords: 0,
            loading: false,
            LiveVisitorsDetailsList: [],
            emp_name: '',
            host_name: '',
            branch_name: '',
            visitorsdatadisplayflag: false,
            admin_id: '',
            host_id: '',
            branch_id: '',
            admin_list_status: false,
            host_list_status: false,
            branch_list_status: false,
            itemsPerPage: 30,
            openGuestHistoryPopUpStatus: false,
            guestHistoryList: [],
            guestHistoryCount: 0,
            currentVisitorDetails: [],
            allow_to_display_mobile_number: 0,
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    mounted() {
        this.getAdminListOnly();

        const localdata = JSON.parse(localStorage.user);
        this.allow_to_display_mobile_number = localdata.allow_to_display_mobile_number;
    },
    methods: {
        async editGuestHistoryPopUpOpen(data) {
            this.currentVisitorDetails = data;
            this.ApiService.getGuestHistory({ clientId: this.admin_id, visitorId: data.aa1 }).then((data) => {
                if (data.status == 200) {
                    this.guestHistoryList = data.data;
                    this.guestHistoryCount = data.count;
                } else {
                    this.guestHistoryList = null;
                }
            });
            this.openGuestHistoryPopUpStatus = true;
        },
        getAdminListOnly(e) {
            this.ApiService.getAdminListOnly(e).then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    if (data.data.records.length == 1) {
                        this.getAdminVisitorsDetails({ value: data.data.records[0] });
                        this.emp_name = data.data.records[0];
                    }
                } else {
                    this.adminList = null;
                }
            });
        },
        getAdminVisitorsDetails(e) {
            this.visitorsdatadisplayflag = true;
            this.loading = true;
            if (e) {
                this.page_no = 0;
                this.admin_id = e.value.value;
            }
            // this.ApiService.getAllVisitorsDetails({ clientId: this.admin_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
            //     if (data.success === true) {
            //         this.VisitorsDetailsList = data.data.result;
            //         this.VisitorsTotalRecords = data.data.count;
            //         this.loading = false;
            //         this.admin_list_status = true;
            //         this.host_name = '';
            //         this.branch_name = '';
            //         if (e) {
            //             this.getHostListOnly(e);
            //         }
            //     }
            // });
            this.ApiService.getAllLiveVisitorsDetails({ clientId: this.admin_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
                if (data.success === true) {
                    this.LiveVisitorsDetailsList = data.data.result;
                    this.LiveVisitorsTotalRecords = data.data.count;
                    this.loading = false;
                    this.admin_list_status = true;
                    this.host_name = '';
                    this.branch_name = '';
                    if (e) {
                        this.getHostListOnly(e);
                    }
                }
            });
        },
        onPageChange(e) {
            this.loading = true;
            if (this.admin_list_status) {
                this.page_no = e.page;
                this.getAdminVisitorsDetails();
            }
            if (this.host_list_status) {
                this.page_no = e.page;
                this.getHostVisitorsDetails();
            }
            if (this.branch_list_status) {
                this.page_no = e.page;
                this.getHostBranchVisitorsDetails();
            }
        },
        getHostListOnly(e) {
            this.ApiService.getHostListOnly({ clientId: e.value.value }).then((data) => {
                if (data.status == 200) {
                    this.hostList = data.data.records;
                } else {
                    this.hostList = null;
                }
            });
        },
        getHostVisitorsDetails(e) {
            this.loading = true;
            if (e) {
                this.page_no = 0;
                this.host_id = e.value.value;
            }
            this.ApiService.getAllLiveVisitorsDetailsByHost({ clientId: this.admin_id, hostId: this.host_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
                if (data.success === true) {
                    this.LiveVisitorsDetailsList = data.data.result;
                    this.LiveVisitorsTotalRecords = data.data.count;
                    this.loading = false;
                    this.visitorsdatadisplayflag = true;
                    this.admin_list_status = false;
                    this.host_list_status = true;
                    this.branch_name = '';
                    if (e) {
                        this.getHostBranchListOnly(e);
                    }
                }
            });
        },
        getHostBranchListOnly(e) {
            this.host_id = e.value.value;
            this.ApiService.getHostBranchesOnly({ clientId: this.admin_id, hostId: e.value.value }).then((data) => {
                if (data.status == 200) {
                    this.branchList = data.data;
                } else {
                    this.branchList = null;
                }
            });
        },
        getHostBranchVisitorsDetails(e) {
            if (e) {
                this.page_no = 0;
                this.branch_id = e.value.value;
            }
            this.loading = true;
            this.ApiService.getAllLiveVisitorsDetailsByBranches({ clientId: this.admin_id, hostId: this.host_id, branchId: this.branch_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
                if (data.success === true) {
                    this.LiveVisitorsDetailsList = data.data.result;
                    this.LiveVisitorsTotalRecords = data.data.count;
                    this.loading = false;
                    this.visitorsdatadisplayflag = true;
                    this.admin_list_status = false;
                    this.host_list_status = true;
                    this.branch_list_status = true;
                }
            });
        },
        // format_timestamp(value) {
        //     if (value) {
        //         var localTime = new Date(value * 1000).toUTCString();
        //         return moment(localTime).format("DD/MM/YYYY @ hh:mm A");
        //     } else {
        //         return 'N/A';
        //     }
        // },
        format_timestamp(value) {
            if (value) {
                var localTime = new Date(value * 1000).toUTCString();
                return {
                    date: moment(localTime).format("DD/MM/YYYY"),
                    time: moment(localTime).format("hh:mm A"),
                };

            } else {
                return {
                    date: 'N/A',
                    time: 'N/A',
                };

            }
        },
    },
};
</script>
<style scoped lang="scss"></style>
